/* ZWIM Swim Pace tool — external (deferred). Inputs are rebuilt ONLY on mode/unit change.
   Typing fires compute() only, which never touches the input fields — so values persist. */
(function(){
  var app=document.getElementById('ztf-app'); if(!app) return;
  var mode='pace', unit='m';
  var $=function(id){return document.getElementById(id);};
  function pt(v){v=(''+(v==null?'':v)).trim();if(!v)return 0;v=v.replace(/[.]/g,':');if(v.indexOf(':')<0)return parseFloat(v)||0;var p=v.split(':').map(function(x){return parseFloat(x)||0;});while(p.length<3)p.unshift(0);return p[0]*3600+p[1]*60+p[2];}
  function pace(s){if(!isFinite(s)||s<=0)return'--';var m=Math.floor(s/60),x=Math.round(s-m*60);if(x===60){m++;x=0;}return m+':'+(x<10?'0':'')+x;}
  function clock(s){if(!isFinite(s)||s<=0)return'--';var h=Math.floor(s/3600),m=Math.floor((s-h*3600)/60),x=Math.round(s%60);if(x===60){x=0;m++;}if(m===60){m=0;h++;}var mm=(m<10?'0':'')+m,xx=(x<10?'0':'')+x;return h>0?(h+':'+mm+':'+xx):(m+':'+xx);}
  var I='inputmode="decimal" autocomplete="off"';
  function setHero(big,cap,unitTxt){
    var b=$('ztf-big'); $('ztf-cap').textContent=cap; $('ztf-bigunit').textContent=unitTxt;
    if(b.textContent!==big){b.textContent=big;b.classList.add('pulse');setTimeout(function(){b.classList.remove('pulse');},180);
      if(window.__zwimTrack)window.__zwimTrack('tool_calc_run',{tool:'swim_pace',mode:mode,unit:unit});}
  }
  function chips(arr){return '<div class="ztf__chips">'+arr.map(function(c){return '<div class="ztf__chip '+(c.cls||'')+'"><div class="k">'+c.k+'</div><div class="v">'+c.v+'</div></div>';}).join('')+'</div>';}

  /* Build the input fields for the current mode/unit. Called ONLY on mode/unit change + init. */
  function buildInputs(){
    var inp=$('ztf-inputs'), u=unit;
    if(mode==='pace'){
      inp.innerHTML='<div class="ztf__f"><label>Distance ('+u+')</label><input id="i-d" value="1500" '+I+'></div><div class="ztf__f"><label>Time (mm:ss)</label><input id="i-t" value="24:00" '+I+'></div>';
    } else if(mode==='time'){
      inp.innerHTML='<div class="ztf__f"><label>Distance ('+u+')</label><input id="i-d" value="1900" '+I+'></div><div class="ztf__f"><label>Target /100 (m:ss)</label><input id="i-p" value="1:50" '+I+'></div>';
    } else {
      inp.innerHTML='<div class="ztf__f"><label>400'+u+' time</label><input id="i-4" value="6:40" '+I+'></div><div class="ztf__f"><label>200'+u+' time</label><input id="i-2" value="3:10" '+I+'></div>';
    }
    inp.querySelectorAll('input').forEach(function(e){ e.addEventListener('input', compute); });
  }

  /* Read inputs + update result. NEVER rewrites the input fields, so typed values persist. */
  function compute(){
    var ex=$('ztf-extra'), u=unit;
    if(mode==='pace'){
      var d=+(($('i-d')||{}).value)||0, t=pt(($('i-t')||{}).value);
      var p100=(d>0&&t>0)?t/(d/100):0, p50=(d>0&&t>0)?t/(d/50):0, spd=(d>0&&t>0)?d/t:0;
      setHero(pace(p100),'Pace per 100'+u,'min / 100'+u);
      var html=chips([{k:'Per 50'+u,v:pace(p50)},{k:'Speed',v:(spd>0?spd.toFixed(2):'--')+' '+u+'/s'},{k:'Total',v:t>0?clock(t):'--'}]);
      var p100m=(unit==='m')?p100:p100*1.0936;
      var races=[{d:750,n:'Sprint',c:'s-sprint'},{d:1500,n:'Olympic',c:'s-oly'},{d:1900,n:'70.3',c:'s-half'},{d:3800,n:'Ironman',c:'s-iron'}];
      html+='<div class="ztf__splits">'+races.map(function(r){return '<div class="ztf__split '+r.c+'"><div class="d">'+r.n+'</div><div class="dist">'+r.d+' m</div><div class="t">'+(p100m>0?clock(p100m*(r.d/100)):'--')+'</div></div>';}).join('')+'</div>';
      ex.innerHTML=html;
      $('ztf-hint').textContent='Race splits at this pace. Open water usually runs slower.';
    } else if(mode==='time'){
      var d2=+(($('i-d')||{}).value)||0, pp=pt(($('i-p')||{}).value);
      var tot=(d2>0&&pp>0)?pp*(d2/100):0;
      setHero(tot>0?clock(tot):'--','Projected total time','for '+(d2||'--')+' '+u);
      ex.innerHTML=chips([{k:'Pace /100'+u,v:pace(pp)},{k:'Per 50'+u,v:pace(pp/2)},{k:'Distance',v:(d2||'--')+' '+u}]);
      $('ztf-hint').textContent='A projection, not a race promise. Conditions change race day.';
    } else {
      var t4=pt(($('i-4')||{}).value), t2=pt(($('i-2')||{}).value);
      var css=(t4>t2&&t2>0)?(t4-t2)/2:0;
      setHero(css>0?pace(css):'--','CSS pace per 100'+u,'threshold');
      ex.innerHTML=chips([
        {k:'Easy / Recovery',v:css>0?pace(css+12):'--',cls:'z-end'},
        {k:'Endurance',v:css>0?pace(css+6):'--',cls:'z-end'},
        {k:'Threshold',v:css>0?pace(css):'--',cls:'z-thr'},
        {k:'VO2 / fast',v:css>0?pace(Math.max(1,css-4)):'--',cls:'z-vo2'}]);
      $('ztf-hint').textContent='Your training zones from a 400m + 200m test. Endurance is easier, VO2 is faster.';
    }
  }

  function bindGroup(id, set){
    $(id).querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        $(id).querySelectorAll('button').forEach(function(x){x.classList.remove('on');x.setAttribute('aria-selected','false');});
        b.classList.add('on'); b.setAttribute('aria-selected','true');
        set(b); buildInputs(); compute();
      });
    });
  }
  bindGroup('ztf-modes', function(b){ mode=b.getAttribute('data-mode'); });
  bindGroup('ztf-unit', function(b){ unit=b.getAttribute('data-unit'); });

  buildInputs();
  compute();
})();
